import useUserRoles from "hooks/use-user-roles.hook";

import usePracticeVoiceEnabled from "./use-practice-voice-enabled.hook";
import useVoiceSeat from "./use-voice-seat.hook";

// Who may open the Voice screens — /calls (workspace, Rolodex, call logs,
// voicemails, Analytics) and a patient's Calls tab: seat holders, plus Suno
// staff on any practice with Voice, so support can see a practice's calls
// without a phone. A role on its own grants nothing (ENG-2315). The backend's
// `IsVoiceUser` is the same rule, so the route, the menu, the tabs and the API
// always agree.
export default function useCanUseVoiceScreens(): boolean {
  const hasVoiceSeat = useVoiceSeat();
  const isPracticeVoiceEnabled = usePracticeVoiceEnabled();
  const { isSunoAdmin } = useUserRoles();
  return hasVoiceSeat || (isPracticeVoiceEnabled && isSunoAdmin);
}
